var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-header',{attrs:{"title":"添加用户","isReturn":"true"}}),_c('div',{staticClass:"user-code"},[_vm._m(0),_c('div',{staticClass:"code-wx"},[_vm._v("扫描以下二维码")]),_c('div',{staticClass:"code-img"},[_c('img',{attrs:{"src":_vm.code}})])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-wx"},[_vm._v("请使用"),_c('span',[_vm._v("微信")]),_vm._v("扫一扫")])
}]

export { render, staticRenderFns }